webpackJsonp([224989948613620],{

/***/ 364:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/2017-01-05-using-git-for-docs/"},"frontmatter":{"title":"Using Git for Docs"}}}]}},"pathContext":{"tag":"git"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-git-51a4688c0f7caae48a84.js